import { Snackbar, SnackbarContent, tooltipClasses } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const onUniqueProp = (propName) => (value, index, self) => {
  return self.map((item) => item[propName]).indexOf(value[propName]) === index;
};
export const mapOnUniqueProp = (propName, array) => {
  const hashMap = new Map();
  array.map((data) => {
    const curr = hashMap.get(data[propName]);

    if (curr) {
      let desc = data.description + "####" + curr.description;
      console.log(data.description, "xxxxxx", curr.description);
      desc = Array.from(new Set(desc.split("####")).values())
        .filter((value) => !!value)
        .join("####");
      hashMap.set(data[propName], {
        ...curr,
        description: desc,
      });
    } else {
      hashMap.set(data[propName], data);
    }
  });
  return Array.from(hashMap.values());
};

export function formatNumber(number) {
  const formattedNumber =
    number === -1
      ? -1
      : number === 0
      ? 0
      : parseInt(number).toLocaleString("en-IN");
  return formattedNumber;
}

export function moveMonth(newDate, number) {
  return new Date(
    new Date(newDate).setMonth(new Date(newDate).getMonth() + number)
  ).getMonth();
}

export function getISODate(date) {
  const offset = date.getTimezoneOffset();
  date = new Date(date.getTime() - offset * 60 * 1000);
  return date.toISOString();
}

const Days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export function getDateDDMM(date) {
  return (
    new Date(date).toLocaleDateString("en-GB").split("/")[0] +
    `/` +
    new Date(date).toLocaleDateString("en-GB").split("/")[1]
  );
}
export function getDateDDMMYYYY(date) {
  return (
    new Date(date).toLocaleDateString("en-GB").split("/")[0] +
    `/` +
    new Date(date).toLocaleDateString("en-GB").split("/")[1] +
    "/" +
    (new Date(date).toLocaleDateString("en-GB").split("/")[2] % 100)
  );
}
export function getFullDate(date) {
  return (
    new Date(date).toLocaleDateString("en-GB").split("/")[0] +
    `/` +
    new Date(date).toLocaleDateString("en-GB").split("/")[1] +
    "/" +
    new Date(date).toLocaleDateString("en-GB").split("/")[2]
  );
}
export function getDay(date) {
  return Days[new Date(date).getDay()];
}

export function getHrMin(dateString) {
  const date = new Date(dateString);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const am_pm = hours >= 12 ? "PM" : "AM";
  hours %= 12;
  hours = hours ? hours : 12;

  // return `${hours}:${minutes} ${am_pm}`;
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes} ${am_pm}`;
}

export function searchParamsToUrlQuery(searchParams) {
  const query = {};
  searchParams.forEach((value, key) => {
    if (typeof query[key] === "undefined") {
      query[key] = value;
    } else if (Array.isArray(query[key])) {
      query[key].push(value);
    } else {
      query[key] = [query[key], value];
    }
  });
  return query;
}

export function formatDateToYYYYMMDD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function downloadExcelFile({ fileUrl }) {
  const link = document.createElement("a");
  link.href = fileUrl;

  const urlParts = fileUrl.split("/");
  let fileName = urlParts[urlParts.length - 1].split("?")[0];
  if (!fileName) fileName = "downloaded_file.xlsx";

  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function getPrevDate(beforedays) {
  // how much days before date from now you want, pass as number
  const date = new Date();
  date.setDate(date.getDate() - beforedays);
  return date;
}

export function capitalizeFirstLetter(val) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

export function addHoursToTime(time, hoursToAdd) {
  if (typeof time !== "string" || !time.includes(":")) {
    return "N/A";
  }
  const [hoursStr, minutesStr] = time.split(":");
  let hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);
  if (isNaN(hours) || isNaN(minutes)) {
    return "N/A";
  }
  hours = (hours + hoursToAdd) % 24;
  // Format back to "HH:MM"
  const newTime = `${hours
    .toString()
    .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  return newTime;
}
export const convertToTimezone = (date,timezone,timeFormat) => {
  if (!date || !timezone) {
    return "";
  }
  return dayjs.utc(date).tz(timezone).format(timeFormat);
};

export const customTooltipProps = {
  popper: {
    sx: {
      [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
        marginTop: "0px",
      },
    },
  },
};


export function formatDateDDMMYYYY(date) {
  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
}